let visits = function(i) {
	this.$router.push({ name: 'btnCallLinkVisits', params: { id: i}})
};
export default visits;
